module.exports = __webpack_public_path__ + "img/back-arrow-icon.527ed54d.svg";